import styled from 'styled-components'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {PrimaryButtonStyledLink} from '../../styledComponents/Links'

export const DescriptionArea = styled.div`
  margin: 20px 0px;
  word-break: normal;
  line-break: strict;
`

export const WhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `}
  padding: 20px 15px;
  box-sizing: border-box;
  word-break: normal;
  line-break: strict;
`

export const ApplyButton = styled(PrimaryButtonStyledLink)`
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
`

export const ListGridContainer = styled.div<{ fontSize?: string }>`
  display: grid;
  grid-template-columns: min-content auto;
  ${props => props.fontSize ? `
    font-size:${props.fontSize};
  ` : ''}
`

export const ListNumber = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: bold;
  color: ${Colors.Primary};
  width: 27px;
`

export const ListHeader = styled.div`
  font-size: ${FontSize.Body};
  font-weight: bold;
  color: ${Colors.AccentDark};
  transform: translateY(3px);
`

export const BoldText = styled.span`
  font-weight: ${FontWeights.Bold};
`

export const PcMarginLeft15 = styled.div`
  ${currentMedia.greaterThan('pc')`
    margin-left:15px;
  `}
`

export const PcMarginLeft30 = styled.div`
  ${currentMedia.greaterThan('pc')`
    margin-left:30px;
  `}
`

export const CompleteSampleArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.Background};
  height: 238px;
  width: 67%;
  margin: 0 auto;
`
